/* eslint-disable import/no-namespace */
import * as types from '../../actions';

const EVENT_TYPES = types.types.Event;

const mapDirectorStats = function(searchResults) {
  let totalAmountPaid = 0;
  let totalPaymentDue = 0;
  let totalBalance = 0;
  let eventDirector = '';

  if (searchResults.length > 0){

    totalAmountPaid = searchResults.reduce(function(total, arr) {
      return total + arr.amountPaid;
    },0);

    totalPaymentDue = searchResults.reduce(function(total, arr) {
      return total + arr.paymentDue;
    },0);

    totalBalance = searchResults.reduce(function(total, arr) {
    return total + arr.balance;
    },0);

    eventDirector = searchResults[0].directorName;
  }

  const stats = {
    totalAmountPaid,
    totalPaymentDue,
    totalBalance,
    eventDirector
  }
  
  return stats;
}

export default function managefunds(state = {}, action) {
  
  switch (action.type) {

    case EVENT_TYPES.TRANSFERRING_FUNDS:
    {
      return {
        ...state,
        values: {
          ...state.values,
          savingTransfer: true
        },
        fields: {
          ...state.fields,
          savingTransfer: true
        }
      }
    }

    case EVENT_TYPES.TRANSFER_FUNDS:
    {
      let searchResults;

      if (action.payload !== undefined)
      {
        searchResults = action.payload;
        const stats = mapDirectorStats(searchResults);
      
        return {
          ...state,
          values: {
            ...state.values,
            savingTransfer: false,
            searchResults,
            totalAmountPaid: stats.totalAmountPaid,
            totalPaymentDue: stats.totalPaymentDue,
            totalBalance: stats.totalBalance,
            eventDirector: stats.eventDirector
          },
          fields: {
            ...state.fields,
            savingTransfer: false,
            searchResults,
            totalAmountPaid: stats.totalAmountPaid,
            totalPaymentDue: stats.totalPaymentDue,
            totalBalance: stats.totalBalance,
            eventDirector: stats.eventDirector
          }
        }
      }
      return state;
    }

    case EVENT_TYPES.ADJUST_FUNDS:
    {
      let searchResults;

      if (action.payload !== undefined)
      {
        searchResults = action.payload;
        const stats = mapDirectorStats(searchResults);

        return {
          ...state,
          values: {
            ...state.values,
            searchResults,
            savingAdjustment: false,
            totalAmountPaid: stats.totalAmountPaid,
            totalPaymentDue: stats.totalPaymentDue,
            totalBalance: stats.totalBalance,
            eventDirector: stats.eventDirector
          },
          fields: {
            ...state.fields,
            searchResults,
            savingAdjustment: false,
            totalAmountPaid: stats.totalAmountPaid,
            totalPaymentDue: stats.totalPaymentDue,
            totalBalance: stats.totalBalance,
            eventDirector: stats.eventDirector
          }
        }
      } 
      return state;
    }

    case EVENT_TYPES.ADJUSTING_FUNDS:
    {
      return {
        ...state,
        values: {
          ...state.values,
          savingAdjustment: true
        },
        fields: {
          ...state.fields,
          savingAdjustment: true
        }
      }
    }

    case EVENT_TYPES.FETCHING_EVENT_DIRECTOR_EVENTS:
    {
      return {
        ...state,
        values: {
          ...state.values,
          searchMode: true
        },
        fields: {
          ...state.fields,
          searchMode: true
        }
      }
    }

    case EVENT_TYPES.FETCH_EVENT_DIRECTOR_EVENTS:
    {
      if (action.payload !== undefined){
        const searchResults = action.payload;
        const stats = mapDirectorStats(searchResults);

        return {
          ...state,
          values: {
            ...state.values,
            searchMode: false,
            showSearchResultsMode: true,
            searchResults,
            totalAmountPaid: stats.totalAmountPaid,
            totalPaymentDue: stats.totalPaymentDue,
            totalBalance: stats.totalBalance,
            eventDirector: stats.eventDirector
          },
          fields: {
            ...state.fields,
            searchMode: false,
            showSearchResultsMode: true,
            searchResults,
            totalAmountPaid: stats.totalAmountPaid,
            totalPaymentDue: stats.totalPaymentDue,
            totalBalance: stats.totalBalance,
            eventDirector: stats.eventDirector
          }
        }
      }
      return state;
    }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/managefunds.js